export default __webpack_public_path__ + "static/k12-circle-aecf970ed231151be0791e723f355e69.png";